var _g, _path, _path2, _circle, _circle2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChangePasswordSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23430_234789)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 70,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.875 54V59.25C93.775 59.1 92.525 59.025 91.125 59V54C91.125 46.125 88.9 40.875 78 40.875C67.1 40.875 64.875 46.125 64.875 54V59C63.475 59.025 62.225 59.1 61.125 59.25V54C61.125 46.75 62.875 37.125 78 37.125C93.125 37.125 94.875 46.75 94.875 54Z",
    fill: "#292A2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.875 59.25C93.775 59.1 92.525 59.025 91.125 59H64.875C63.475 59.025 62.225 59.1 61.125 59.25C54.75 60.025 53 63.15 53 71.5V76.5C53 86.5 55.5 89 65.5 89H90.5C100.5 89 103 86.5 103 76.5V71.5C103 63.15 101.25 60.025 94.875 59.25ZM69.775 75.775C69.3 76.225 68.65 76.5 68 76.5C67.675 76.5 67.35 76.425 67.05 76.3C66.725 76.175 66.475 76 66.225 75.775C65.775 75.3 65.5 74.65 65.5 74C65.5 73.675 65.575 73.35 65.7 73.05C65.825 72.75 66 72.475 66.225 72.225C66.475 72 66.725 71.825 67.05 71.7C67.975 71.3 69.075 71.525 69.775 72.225C70 72.475 70.175 72.75 70.3 73.05C70.425 73.35 70.5 73.675 70.5 74C70.5 74.65 70.225 75.3 69.775 75.775ZM80.3 74.95C80.175 75.25 80 75.525 79.775 75.775C79.3 76.225 78.65 76.5 78 76.5C77.325 76.5 76.7 76.225 76.225 75.775C76 75.525 75.825 75.25 75.7 74.95C75.575 74.65 75.5 74.325 75.5 74C75.5 73.325 75.775 72.7 76.225 72.225C77.15 71.3 78.825 71.3 79.775 72.225C80.225 72.7 80.5 73.325 80.5 74C80.5 74.325 80.425 74.65 80.3 74.95ZM89.775 75.775C89.3 76.225 88.65 76.5 88 76.5C87.35 76.5 86.7 76.225 86.225 75.775C85.775 75.3 85.5 74.675 85.5 74C85.5 73.325 85.775 72.7 86.225 72.225C87.175 71.3 88.85 71.3 89.775 72.225C89.875 72.35 89.975 72.475 90.075 72.625C90.175 72.75 90.25 72.9 90.3 73.05C90.375 73.2 90.425 73.35 90.45 73.5C90.475 73.675 90.5 73.85 90.5 74C90.5 74.65 90.225 75.3 89.775 75.775Z",
    fill: "#292A2E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 86.5,
    r: 15.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 86.5,
    r: 12.5,
    fill: "#00AC56"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23430_234789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.5 82.75L93.625 89.625L90.5 86.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23430_234789",
    x: 0.5,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23430_234789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23430_234789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23430_234789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(88 79)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChangePasswordSuccess);
export default __webpack_public_path__ + "static/media/ic_change_password_success.16ee6322f0ba93e0b6cc3d48f8bb855d.svg";
export { ForwardRef as ReactComponent };